const PageContainer = ({ children, className = "" }) => {
  return <div className={`page ${className}`}>{children}</div>;
};

export default PageContainer;
